var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskCenteredLayout",
    [
      _c("div", { class: _vm.$style.checkmark }, [
        _c("svg", {
          directives: [{ name: "svg", rawName: "v-svg" }],
          class: _vm.$style.checkmarkIcon,
          attrs: { symbol: "checkmark-icon" }
        })
      ]),
      _vm._v(" "),
      _c("KioskMessageTitle", { attrs: { title: "Discount Code Applied!" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskDiscountApply.vue?vue&type=template&id=23d1efda&
// module id = null
// module chunks = 